export default __webpack_public_path__ + "static/media/kid08.5f780aa5.jpg";